(() => {
  if (window.khmsCartFlowReady) return;
  window.khmsCartFlowReady = true;

  const refresh = (root) => {
    const selected = root.querySelector('input[name="attributes[Kundetype]"]:checked');
    const fields = root.querySelector('[data-khms-business-fields]');
    const company = root.querySelector('[data-khms-company-name]');
    const org = root.querySelector('[data-khms-org-number]');

    root.querySelectorAll('.khms-customer-type__option').forEach((option) => {
      option.classList.toggle('is-selected', Boolean(option.querySelector('input:checked')));
    });

    const business = Boolean(selected && selected.value === 'Bedrift');
    if (fields) fields.classList.toggle('hide', !business);

    if (!business && selected) {
      if (company) company.value = '';
      if (org) org.value = '';
    }
  };

  const save = (root) => {
    const selected = root.querySelector('input[name="attributes[Kundetype]"]:checked');
    const company = root.querySelector('[data-khms-company-name]');
    const org = root.querySelector('[data-khms-org-number]');
    const business = Boolean(selected && selected.value === 'Bedrift');
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(rootUrl + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          Kundetype: selected ? selected.value : '',
          Firmanavn: business && company ? company.value.trim() : '',
          Organisasjonsnummer: business && org ? org.value.trim() : ''
        }
      })
    }).catch(() => {});
  };

  const refreshAll = () => {
    document.querySelectorAll('[data-khms-customer-type]').forEach(refresh);
  };

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-khms-direct-checkout]');
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = '/checkout';
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches('input[name="attributes[Kundetype]"]')) return;
    const root = event.target.closest('[data-khms-customer-type]');
    if (!root) return;
    refresh(root);
    save(root);
  });

  document.addEventListener('focusout', (event) => {
    if (!event.target.matches('[data-khms-company-name], [data-khms-org-number]')) return;
    const root = event.target.closest('[data-khms-customer-type]');
    if (root) save(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll, { once: true });
  } else {
    refreshAll();
  }
})();